import { GetAcceptFormatQuestionsResponse } from './getAcceptFormatQuestionsResponse';

const answerList = new Array(4).fill(undefined).map((item, index) => ({
  answerId: `answer${index}`,
  answerText: `Answer Text ${index}`,
}));

const acceptFormatQuestionList = new Array(4)
  .fill(undefined)
  .map((item, index) => ({
    questionId: `question${index}`,
    questionText: `Question text ${index}?`,
    required: true,
    fieldSeq: 0,
    groupSeq: 0,
    answerType: undefined,
    answerDefault: index !== 1 ? 'answer1' : undefined,
    answerList: answerList,
  }));

const mockData = {
  acceptFormatQuestionList: acceptFormatQuestionList,
};

export const GetAcceptFormatQuestionsServiceMock: GetAcceptFormatQuestionsResponse =
  {
    data: mockData,
    succeeded: true,
  };
